import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import {CreateEventsVirtual, EventsApiService } from 'features/events';
import { queryClient } from 'providers';

import { eventsQueryKeys } from './query-keys';

const { createVirtualEvents } = EventsApiService();

export const useEventsVirtualEvents = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: CreateEventsVirtual) => {
      return createVirtualEvents(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: eventsQueryKeys.all,
        });
      },
    },
  );
};
